import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Termeni() {
  return (
    <LegalLayout
      title="Termeni și condiții"
      subtitle="Termenii și condițiile de utilizare a magazinului Detecogreen."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">1. Date despre vânzător</h2>
      <p>
        Site-ul <strong>detereco-green.ro</strong> este deținut și administrat de{" "}
        <strong>{COMPANY.legalName}</strong>, cu sediul în {COMPANY.address},
        înregistrată la Registrul Comerțului cu numărul {COMPANY.regCom}, CUI{" "}
        {COMPANY.cui}. Contact: {COMPANY.email}, {COMPANY.phone}.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">2. Acceptarea termenilor</h2>
      <p>
        Prin accesarea și utilizarea acestui site, vă exprimați acordul deplin cu
        prezentele termene și condiții. Dacă nu sunteți de acord cu acestea, vă
        rugăm să nu utilizați site-ul.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">3. Procedura de comandă</h2>
      <p>
        Comenzile se plasează prin <strong>WhatsApp</strong> sau prin{" "}
        <strong>apel telefonic</strong> la numărul {COMPANY.phone}. După plasarea
        comenzii, un reprezentant vă va contacta pentru confirmarea detaliilor de
        livrare și a metodei de plată.
      </p>
      <p>
        Comanda devine fermă în momentul confirmării telefonice/WhatsApp a
        produselor, prețului, adresei de livrare și a modalității de plată.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">4. Prețuri și plată</h2>
      <p>
        Prețurile afișate pe site sunt în lei (RON) și sunt finale. Plata se face{" "}
        <strong>numerar la curier (ramburs)</strong> în momentul livrării.
        Eventualele costuri suplimentare de transport vor fi comunicate înainte
        de confirmarea finală.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">5. Livrare</h2>
      <p>
        Detalii complete despre livrare găsiți în{" "}
        <a href="/politica-livrare" className="text-cyan-600 underline">
          Politica de livrare
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">6. Drept de retragere și retur</h2>
      <p>
        Conform OUG 34/2014, aveți dreptul să returnați produsele în termen de 14
        zile calendaristice, fără a invoca motive. Detalii complete în{" "}
        <a href="/politica-retur" className="text-cyan-600 underline">
          Politica de retur
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">7. Garanție</h2>
      <p>
        Toate produsele beneficiază de garanția conformității conform Legii
        449/2003. Detalii în{" "}
        <a href="/politica-garantie" className="text-cyan-600 underline">
          Politica de garanție
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">8. Protecția datelor</h2>
      <p>
        Datele cu caracter personal sunt prelucrate conform legislației în
        vigoare (GDPR – Regulamentul UE 2016/679). Vezi{" "}
        <a href="/politica-confidentialitate" className="text-cyan-600 underline">
          Politica de confidențialitate
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">9. Soluționarea litigiilor</h2>
      <p>
        Eventualele dispute se vor soluționa pe cale amiabilă. În caz contrar,
        consumatorii se pot adresa <strong>ANPC</strong> (anpc.ro) sau pot
        utiliza platforma europeană <strong>SOL</strong> (Soluționare Online a
        Litigiilor):{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-600 underline"
        >
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">10. Modificarea termenilor</h2>
      <p>
        Ne rezervăm dreptul de a modifica acești termeni în orice moment.
        Modificările intră în vigoare la momentul publicării pe site.
      </p>
    </LegalLayout>
  );
}
